import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from 'lib-trend-core';
import { TrackingRoutingModule } from './tracking-routing.module';
import { TrackingComponent } from './tracking.component';

@NgModule({
  imports: [
    TrackingRoutingModule,
    SharedModule,
  ],
  declarations: [
    TrackingComponent,
  ],
  exports: [
    TrackingComponent
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TrackingModule { }
